<template>
  <div>
    <PresaleHeader />
    <hr />
    <PresaleGroupInfo />
    <hr />
    <PresaleHighlights />
    <hr />
    <PresaleForm />
  </div>
</template>

<script setup lang="ts">
useHead({
	title: "Circus St. Ottilien • Vorverkauf",
});
</script>
